import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './facility-warehouse.reducer';

export const FacilityWarehouseDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const facilityWarehouseEntity = useAppSelector(state => state.facilityWarehouse.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="facilityWarehouseDetailsHeading">
          <Translate contentKey="integrawebApp.facilityWarehouse.detail.title">FacilityWarehouse</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{facilityWarehouseEntity.id}</dd>
          <dt>
            <span id="stdwaein">
              <Translate contentKey="integrawebApp.facilityWarehouse.stdwaein">Stdwaein</Translate>
            </span>
          </dt>
          <dd>{facilityWarehouseEntity.stdwaein ? 'true' : 'false'}</dd>
          <dt>
            <span id="stdwaaus">
              <Translate contentKey="integrawebApp.facilityWarehouse.stdwaaus">Stdwaaus</Translate>
            </span>
          </dt>
          <dd>{facilityWarehouseEntity.stdwaaus ? 'true' : 'false'}</dd>
          <dt>
            <span id="stdqs">
              <Translate contentKey="integrawebApp.facilityWarehouse.stdqs">Stdqs</Translate>
            </span>
          </dt>
          <dd>{facilityWarehouseEntity.stdqs ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="integrawebApp.facilityWarehouse.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {facilityWarehouseEntity.createdDate ? (
              <TextFormat value={facilityWarehouseEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="integrawebApp.facilityWarehouse.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{facilityWarehouseEntity.createdBy}</dd>
          <dt>
            <span id="lastModifiedDate">
              <Translate contentKey="integrawebApp.facilityWarehouse.lastModifiedDate">Last Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {facilityWarehouseEntity.lastModifiedDate ? (
              <TextFormat value={facilityWarehouseEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastModifiedBy">
              <Translate contentKey="integrawebApp.facilityWarehouse.lastModifiedBy">Last Modified By</Translate>
            </span>
          </dt>
          <dd>{facilityWarehouseEntity.lastModifiedBy}</dd>
        </dl>
        <Button tag={Link} to="/facility-warehouse" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/facility-warehouse/${facilityWarehouseEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FacilityWarehouseDetail;
